import { VisuallyHidden } from '@reach/visually-hidden'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

const Twitter = () => {
  const productUrl = useSelector(state => state.asset.productUrl)
  const title = useSelector(state => state.asset.title)

  return (
    <li>
      <a
        className='twitter'
        href={
          `https://x.com/intent/post?text=${title}&url=${productUrl}`
        }
        rel='noopener noreferrer'
        target='_blank'
      >
        <p>{"X"}</p>
        <VisuallyHidden>
          <FormattedMessage id='purchase.share_this_ebook_on_x' />
        </VisuallyHidden>
      </a>
    </li>
  )
}

export default Twitter
